import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import dayjs, { Dayjs } from "dayjs";
import DatePickerProps from "@/app/interfaces/props/DatePickerProps";
import { useState, useCallback } from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

const DatePicker = ({
  label,
  value,
  onChange,
  name,
  error = false,
  helperText,
  required = false,
  size = "small",
  disabled = false,
  ...rest
}: DatePickerProps) => {
  const dayjsValue: Dayjs | null = value ? dayjs(value) : null;
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const handleDatePickerOpen = useCallback(() => {
    if (!disabled) {
      setIsDatePickerOpen(true);
    }
  }, [disabled]);

  const handleDatePickerClose = useCallback(() => {
    setIsDatePickerOpen(false);
  }, []);

  const handleDateChange = (newValue: Dayjs | null) => {
    setIsDatePickerOpen(false);

    if (!newValue) {
      return onChange(null);
    }

    const finalValue = newValue.isAfter(dayjs()) ? dayjs() : newValue;
    onChange(finalValue);
  };
  const baseText = {
    fontSize: "14px",
    fontFamily: `"Montserrat", Verdana, sans-serif`,
  } as const;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker<Dayjs>
        label={label}
        value={dayjsValue}
        onChange={handleDateChange}
        maxDate={dayjs()}
        disabled={disabled}
        open={isDatePickerOpen}
        onOpen={handleDatePickerOpen}
        onClose={handleDatePickerClose}
        renderInput={(params) => (
          <TextField
            sx={{
              borderWidth: 1,
              borderColor: "#d9d9d9",
              borderStyle: "solid",
              borderRadius: "4px",
              width: "100%",
              color: "#000",
              alignItems: "baseline",
            }}
            {...params}
            fullWidth
            size={size}
            error={error}
            helperText={helperText}
            required={required}
            name={name}
            variant="standard"
            onClick={handleDatePickerOpen}
            InputProps={{
              disableUnderline: true,
              sx: {
                ...baseText,
                color: "#000",
                height: "32px",
                px: "10px",
                pt: "7px",
                "& input": {
                  fontSize: "14px",
                },
              },
            }}
          />
        )}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
